import { z } from 'zod';
export const UpdateAdminUserSchema = z.object({
    displayName: z.string().min(1).optional(),
    allowedCompanyIds: z.array(z.uuid()).min(1).optional(),
    defaultCompanyId: z.uuid().optional(),
    isActive: z.boolean().optional(),
});
export const CreateAdminUserSchema = z.object({
    entraOid: z.uuid(),
    email: z.email(),
    displayName: z.string().min(1),
    allowedCompanyIds: z.array(z.uuid()).min(1),
    defaultCompanyId: z.uuid(),
    initialRoleIds: z.array(z.uuid()).optional(), // assigned against defaultCompanyId
});
export const DirectoryUserSchema = z.object({
    oid: z.string(),
    displayName: z.string().nullable(),
    mail: z.string().nullable(),
    userPrincipalName: z.string().nullable(),
});
//# sourceMappingURL=admin-users.js.map